import script from "./UserApprovalDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./UserApprovalDetail.vue?vue&type=script&setup=true&lang=js"

import "./UserApprovalDetail.vue?vue&type=style&index=0&id=6181425a&lang=css"
import "./UserApprovalDetail.vue?vue&type=style&index=1&id=6181425a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6181425a"]])

export default __exports__